// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1XydA","label":"Category_label__146qQ","content":"Category_content__351Hf","header":"Category_header__cmHBR","location":"Category_location__24Uvv"};